import Vue from 'vue'
import {VueMasonryPlugin} from 'vue-masonry';
import App from './App.vue'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false
Vue.use(VueMasonryPlugin)

new Vue({
  vuetify,
  render: h => h(App)
}).$mount('#app')
